/* eslint-disable no-invalid-this */
/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
// CONSTANTS are all caps.
const NS ='Careculator';
const CLS ='careculator';
const WG ='.' + CLS +'-';

// Import stuff here if you need to or even better to import them dynamically
// for ex. of dynamic import check out src/scripts/loadWg/careculator.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'
import utils from '../../scripts/utils';
import _ from 'lodash';

export class Careculator {
	constructor($el) {
		// $el is the widget node return by the loadCareculator function
		this.$el = $el;
	}

	init() {
		this.setCareculator();
		this.resizeListener();
	}

	setCareculator() {
		// Add Some logic here
		let $wg = $(this.$el);

		$wg.on('change', '.challengeTypes input, .challengeTypes select', function() {
			let newVal = $(this).val();
			let name = $(this).attr('name');

			$wg.find(`.challengeTypes input[value="${newVal}"]`).prop('checked', true);
			$wg.find(`.challengeTypes select`).val(newVal);
		});
	}

	resizeListener() {
		let $wg = $(this.$el);
		let $radios = $wg.find('.challengeTypes input[type="radio"]');
		let $select = $wg.find('.challengeTypes select');

		$(window).on('resize', _.debounce(() => {
			// resets (remove data-f-datainput from radios, select, and its options)

			$radios.each((index, element) => {
				$(element).removeAttr('data-f-datainput');
			});

			$select.removeAttr('data-f-datainput');

			$select.find('option').each((index, element) => {
				$(element).removeAttr('data-f-datainput');
			});

			if (utils.isSmallerThanTablet()) {
				// mobile
				$select.attr('data-f-datainput', '');

				$select.find('option').each((index, element) => {
					$(element).attr('data-f-datainput', '');
				});
			} else {
				// desktop
				$radios.each((index, element) => {
					$(element).attr('data-f-datainput', '');
				});
			}
		}, 300));

		$(window).trigger('resize');
	}
	// Add more functions like on above here
}
